module.exports = __webpack_public_path__ + "static/img/10.6faf7450.png";